import { trackEvent } from '../../analytics/analyticsTracker';

export function trackPageTimeSpent(pageIndex: number, durationMs: number): void {
  trackEvent({
    eventName: 'page_time_spent',
    metadata: {
      pageIndex,
      durationMs,
    },
  });
}

export function trackValidationError(pageIndex: number, errors: Record<string, string>, attemptNumber: number): void {
  trackEvent({
    eventName: 'validation_error',
    metadata: {
      pageIndex,
      errors,
      attemptNumber,
    },
  });
}
